import { useCallback, useEffect, useRef, useState } from "react";
const emptyTimeout = setTimeout(() => void 0, 0);
function useDebounceValue(value, onChange, delay) {
  const rTimer = useRef(emptyTimeout);
  const [localValue, setLocalValue] = useState(value);
  const rLocalValue = useRef(localValue);
  const rOnChange = useRef(onChange);
  useEffect(() => void (rOnChange.current = onChange), [onChange]);
  useEffect(() => {
    setLocalValue(value);
    rLocalValue.current = value;
    return () => {
      clearTimeout(rTimer.current);
    };
  }, [value]);
  const debounceOnChange = useCallback(
    (nextValue) => {
      clearTimeout(rTimer.current);
      if (delay === void 0 || delay === null || delay < 0) return;
      setLocalValue(nextValue);
      rLocalValue.current = nextValue;
      rTimer.current = globalThis.setTimeout(() => {
        rOnChange.current(rLocalValue.current);
      }, delay);
    },
    [delay]
  );
  const noDebounceOnChange = useCallback((nextValue) => {
    rOnChange.current(nextValue);
  }, []);
  return delay === void 0 || delay === null || delay < 0 ? [value, noDebounceOnChange] : [localValue, debounceOnChange];
}
export {
  useDebounceValue
};
//# sourceMappingURL=useDebounceValue.js.map
